import { LegacyRoute } from "legacyRoutes";

interface BuildControlProgramViewUrlOptions {
    /**
     * When provided, appends a `#control-<id>` fragment so the page scrolls to
     * (and focuses) the given control.
     */
    controlId?: number | string;
}

/**
 * Builds the URL to a control program's detail page.
 */
export function buildControlProgramViewUrl(
    controlProgramId: number | string,
    options?: BuildControlProgramViewUrlOptions
) {
    const url = `${LegacyRoute.CONTROL_PROGRAM}/${controlProgramId}` as const;

    return options?.controlId
        ? (`${url}#control-${options.controlId}` as const)
        : url;
}
